import React from 'react';
import styles from './NightlyStreak.module.css';
import { STATUS_KINDS, statusKind } from './statusConfig';

export default function NightlyStreak({ runs = [], days = 14 }) {
  const recent = runs.slice(-days);
  const padded = Array(Math.max(0, days - recent.length)).fill(null).concat(recent);

  return (
    <div className={styles.bars}>
      {padded.map((run, i) => {
        const tok = run ? STATUS_KINDS[statusKind(run.status)] : null;
        return (
          <span
            key={run ? run.id : `empty-${i}`}
            className={styles.bar}
            style={{ background: tok ? tok.dot : 'var(--gray-200)' }}
            title={run ? `#${run.number} · ${run.status}` : 'No run'}
          />
        );
      })}
    </div>
  );
}
